import * as React from 'react';
import Modal from 'react-modal';
import { Container } from 'react-bootstrap';
import { LoginForm } from './LoginForm';
import './LoginView.scss';
import BusyModal from '../BusyModal/BusyModal';
import { translateService } from '../../services/TranslateService';
// import {ReCaptchaDisclaimer} from "../reCaptchaDisclaimer"; // TODO: re-enable when BE reCaptcha is ready

interface LoginViewProps {
  step: number;
  phoneNumber?: string;
  onNumberSubmit: (s: string) => void;
  onPINSubmit: (pin: string, phoneNumber: string, isChauffeur: boolean) => void;
  onReset: (e: any) => void;
  onEmailLink: () => void;
  apiMessage: string;
  emailLinkVisible: boolean;
  language: string; //passive parameter just used to ensure update after language change
  rootUrl: string;
  loginFromHeader?: boolean;
  // onSetToken: (s: string) => void;
}

const LoginView: React.FC<LoginViewProps> = (props: any) => {
  const onNumberSubmit = (e: { phoneNumber: string }) => {
    props.onNumberSubmit(e.phoneNumber);
  };

  const onPINSubmit = (e: { pin: string; phoneNumber: string }) => {
    props.onPINSubmit(e.pin, e.phoneNumber, true);
  };

  const onStartAgain = (e: any) => {
    props.onReset(e);
  };

  const onEmailLink = () => {
    props.onEmailLink();
  };

  Modal.setAppElement('body');

  return (
    <Container>
      <BusyModal message={props.apiMessage} />
      <section className="login-view">
        <div className="login-container">
          <img width="144" height="30" src={props.rootUrl+'/assets/logos/24rent-logo-dark.svg'} alt="24Rent logo" loading="lazy"/>
          {props.loginFromHeader ? (
              <div>
                {translateService.translate('vehicleSearch1.existingCustomer')}
                <div>
                  {translateService.translate('vehicleSearch1.logInUsingYourPhone')}
                </div>
                {props.step !== 0 && <br/>}
              </div>
          ) : null}
          {props.step === 0
            ? (props.loginFromHeader ? '' : translateService.translate('loginScreen.useNumber'))
            : translateService.translate('loginScreen.enterPin')}
          <LoginForm
            phoneNumber={props.phoneNumber}
            step={props.step}
            onPINSubmit={onPINSubmit}
            onNumberSubmit={onNumberSubmit}
          />
          {props.step === 1 ? (
              <button onClick={onStartAgain} hidden={props.step !== 1} className="mt-3 border-0 bg-white">
                {translateService.translate('loginScreen.startAgain')}
              </button>
          ) : undefined}
          {props.step === 1 && props.emailLinkVisible === true ? (
            <button style={{ color: 'red' }} onClick={onEmailLink} className="mt-3 border-0 bg-white">
              {translateService.translate('loginScreen.emailLink')}
            </button>
          ) : undefined}
          {/* <ReCaptchaDisclaimer lang={props.language}/> */}{/* TODO: re-enable when BE reCaptcha is ready */}
        </div>
      </section>
      <div className="desktop-background-image login-background" />
    </Container>
  );
};

export default LoginView;
